import { useMemo } from "react";
import { Search } from "lucide-react";
import { useTaxonomy } from "../lib/useTaxonomy";

const sel = "bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#D4AF37] w-full";

const Select = ({ label, value, onChange, options, testid }) => (
  <div>
    <label className="block text-[10px] uppercase tracking-widest text-white/40 mb-1.5">{label}</label>
    <select value={value} onChange={(e) => onChange(e.target.value)} className={sel} data-testid={testid}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </div>
);

export const ReminderFilters = ({ f, setF }) => {
  const { centreNames, batches } = useTaxonomy();
  const batchOpts = useMemo(() => batches.filter((b) => !f.centre || b.centre === f.centre).map((b) => [b.name, b.name]), [batches, f.centre]);
  const set = (k) => (v) => setF({ ...f, [k]: v, ...(k === "centre" ? { batch: "" } : {}) });
  return (
    <div className="grid grid-cols-2 lg:grid-cols-7 gap-3 mb-6" data-testid="reminder-filters">
      <div className="col-span-2 lg:col-span-1">
        <label className="block text-[10px] uppercase tracking-widest text-white/40 mb-1.5">Search</label>
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none" />
          <input value={f.search} onChange={(e) => setF({ ...f, search: e.target.value })} placeholder="Player name / ID" className={`${sel} pl-9`} data-testid="reminder-search" />
        </div>
      </div>
      <Select label="Centre" value={f.centre} onChange={set("centre")} options={[["", "All Centres"], ...centreNames.map((c) => [c, c])]} testid="reminder-centre-filter" />
      <Select label="Batch" value={f.batch} onChange={set("batch")} options={[["", "All Batches"], ...batchOpts]} testid="reminder-batch-filter" />
      <Select label="Payment Status" value={f.status} onChange={set("status")} options={[["all", "All With Dues"], ["overdue", "Overdue"], ["due_today", "Due Today"], ["due_7", "Due in 7 Days"], ["due_30", "Due in 30 Days"], ["no_dues", "No Dues"], ["everyone", "Everyone"]]} testid="reminder-status-filter" />
      <Select label="Fee Category" value={f.category} onChange={set("category")} options={[["all", "All"], ["registration", "Registration"], ["group", "Group Coaching"], ["transport", "Transportation"], ["pt", "Personal Training"], ["previous_dues", "Other Charges"]]} testid="reminder-category-filter" />
      <Select label="Coaching Package" value={f.pkg} onChange={set("pkg")} options={[["all", "All Packages"], ["legacy", "Standard Monthly (Legacy)"], ["monthly", "Monthly"], ["quarterly", "Quarterly"], ["half_yearly", "Half-Yearly"], ["annual", "Annual"]]} testid="reminder-package-filter" />
      <Select label="Reminders Sent" value={f.sent} onChange={set("sent")} options={[["all", "Any"], ["8+", "8–30 reminders sent"], ["4-7", "4–7 reminders sent"], ["1-3", "1–3 reminders sent"], ["0", "0 reminders sent"]]} testid="reminder-sent-filter" />
    </div>
  );
};
